import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

// Helpers de formulário
import InputMask from 'react-input-mask';
import Toggle from 'react-toggle';
import getLocale from '../../../i18n/getLocale';

// Importo o moment com a linguagem pt-br
require('moment');
require('moment/locale/pt-br');

class TrainingSimulatorStaffDisapprovedResult extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      loaded: 0,
      id: this.props.training_certification_staff_id,
      hours: '',
      pnf: '',
      disapproved: 0,
      confirmed: 0,
    };

    this.locale = getLocale();

    //bind específico
    this.changeResult = this.changeResult.bind(this);
  }

  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  } 

  handleToggleChange (name, event) {
    var change = {};
    if (event.target.checked === true) {
      var value = 1;
    } else {
      var value = 0;
    }
    change[name] = value;
    this.setState(change);
  } 

  // LM
  componentWillReceiveProps(newProps) {
    if((this.state.loaded === 0 && typeof newProps.training_certification_staff_id !== 'undefined')){
      this.setState({
        hours: newProps.hours,
        pnf: newProps.pnf,
        confirmed: newProps.confirmed,
        status_str: newProps.status_str,
        id: newProps.training_certification_staff_id,
        loaded: 1,
      });
    }
  }
  
  // Fetch salvando resultado do aluno
  changeResult(event) {
    event.preventDefault();
    this.props.handleAlert('', '', 'open');
    var datasave = {
      id: this.state.id,
      pnf: this.state.pnf,
      hours: this.state.hours,
      disapproved: this.state.disapproved,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/treinamento/simulador/certificado/tripulante/resultado', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.props.updateData(responseJson);
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  render() {
    var self = this;
    return (
      <div>
        <RequestApi ref={'request_api'} />
        <form onSubmit={this.changeResult}>
          <table className="table">
            <thead>
              <tr>
                <th className="text-center">{this.locale.Treinamentos.EditarTreinamento.tabResultados.tabelaTripulantes.HorasPF}</th>
                <th className="text-center">{this.locale.Treinamentos.EditarTreinamento.tabResultados.tabelaTripulantes.HorasPNF}</th>
                <th className="text-center">{this.locale.Treinamentos.EditarTreinamento.tabResultados.tabelaTripulantes.Status}</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                  <td>
                    { this.state.confirmed !== 0 ? this.state.hours : '' }
                  </td>
                  <td>
                    { this.state.confirmed !== 0 ? this.state.pnf : '' }
                  </td>
                  <td>
                  {this.state.confirmed === 0 ?
                    <span className="label label-warning">{this.locale.Treinamentos.EditarTreinamento.tabResultados.tabelaTripulantes.Faltante}</span>
                    :
                    <span className="label label-danger">{this.state.status_str}</span>
                  }
                  </td>
              </tr>
            </tbody>
          </table>
        </form>  
      </div>
    );
  }
}

export default TrainingSimulatorStaffDisapprovedResult;



// WEBPACK FOOTER //
// ./src/Components/Trainings/Elements/TrainingSimulatorStaffDisapprovedResult.js